<div class="database-page-container">
  <nz-layout>
    <nz-sider
      [nzWidth]="siderWidth"
      [nzCollapsible]="true"
      [nzCollapsed]="collapsedSider"
      [nzTrigger]="null"
      [nzCollapsedWidth]="collapsedWidth"
    >
      <div [hidden]="collapsedSider">
        <app-database-page-sider
          (collapseEvent)="changeCollapseValue($event)"
          [collapsedSider]="collapsedSider"
        >
        </app-database-page-sider>
      </div>
      <div class="collapsed">
        <va-button
          size="small"
          btnType="outline"
          [isOnlyIcon]="true"
          *ngIf="collapsedSider"
          (click)="toggleSiderFromParent()"
        >
          <va-icon size="small" name="sliders-horizontal"></va-icon>
        </va-button>
      </div>
    </nz-sider>
    <nz-content>
      <div id="db-content">
        <app-save-and-pills [(siderCollapsed)]="collapsedSider">
        </app-save-and-pills>
        <div class="db-container">
          <div id="charts-container">
            <nz-collapse nzExpandIconPosition="'right'">
              <nz-collapse-panel
                [nzHeader]="panel.name"
                [nzActive]="panel.active"
                [nzDisabled]="panel.disabled"
              >
                <div class="charts-content">
                  <div class="drugs-db-charts">
                    <div class="chart-span" style="width: 486px; height: 340px">
                      <app-drugs-by-indication-bar-chart></app-drugs-by-indication-bar-chart>
                    </div>
                    <div class="chart-span" style="width: 166px; height: 340px">
                      <app-drugs-by-phase></app-drugs-by-phase>
                    </div>
                    <div class="chart-span" style="width: 486px; height: 340px">
                      <app-drugs-by-moa></app-drugs-by-moa>
                    </div>
                    <div class="chart-span" style="width: 374px; height: 340px">
                      <app-drugs-by-company></app-drugs-by-company>
                    </div>
                  </div>
                </div>
              </nz-collapse-panel>
            </nz-collapse>
          </div>

          <div id="biopharma-formula-bar-container">
            <app-subheader-formulabar
              [hidden]="auditFormulabarVisible"
              [showNewFbar]="true"
            ></app-subheader-formulabar>
            <app-audit-formulabar
              [hidden]="!auditFormulabarVisible"
            ></app-audit-formulabar>
          </div>
          <div id="grid-container">
            <app-database-grid-container></app-database-grid-container>
          </div>
        </div>
      </div>
    </nz-content>
  </nz-layout>
</div>
